import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { SharedModule } from 'src/app/_shared/shared.module';
import { PinSelectModalComponent } from './pin-select-modal.component';
import { PinSelectModule } from '../pin-select/pin-select.module';

@NgModule({
    imports: [CommonModule, IonicModule, SharedModule, PinSelectModule],
    declarations: [PinSelectModalComponent],
    exports: [PinSelectModalComponent]
})
export class PinSelectModalModule {}
